export const hasData = (r: any[] | undefined | null) => (r?.length ?? 0) > 0
export const count = (r: any[] | undefined | null) => r?.length ?? 0
